module.exports = __webpack_public_path__ + "media/images/admin2/Filter__panel__header__a-4ec0ec8e982a5fb312c61c3a80690865.svg";